import {Button} from 'antd'
import s from "./button.module.scss"
import {ColorContext} from "../../context/colorContext"
import { useContext } from 'react'

export const MyButton = ({children,htmlType,loading,onClick}) => {
  const {color} = useContext(ColorContext)
  return (
    <Button style={{backgroundColor:color}} onClick={onClick} loading={loading} htmlType={htmlType} className = {s.button}>{children}</Button>
  )
}
